import React, { useEffect, useState } from "react";
import { Card, Container, List } from "./styles";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { useAuth } from "../../../hooks/AuthContext";
import { toast } from "react-toastify";
import Status from "../../../components/status";
import { addSeconds, format, intervalToDuration } from "date-fns";
import { Button, Pagination, Select, Spin } from "antd";
import { formatarDuracaoCompleta } from "../../../services/functions";
import { Message, ViewInput } from "../../../GlobalStyles";
import CountUp from "react-countup";

export default function SolicitacoesFranqueados() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [orders, setOrders] = useState([]);
  const [ordersTotal, setOrdersTotal] = useState(0);
  const [collaborator_id, setCollaborator_id] = useState("");
  const [collaborators, setCollaborators] = useState([]);
  const [status, setStatus] = useState("");

  useEffect(() => {
    loadingTecnicos();
  }, []);

  useEffect(() => {
    loadingOSs(status, collaborator_id, page);
  }, [status, collaborator_id, page]);

  async function loadingTecnicos() {
    await api
      .get(`/collaborators?all=true`)
      .then((response) => {
        setCollaborators(response.data.collaborators);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadingOSs(status, collaborator_id, page) {
    setLoading(true);
    await api
      .get(
        `/orders/${user.type}?page=${page}${status && `&status=${status}`}${
          collaborator_id && `&collaborator_id=${collaborator_id}`
        }`
      )
      .then((response) => {
        setOrders(response.data.orders);
        setOrdersTotal(response.data.ordersTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  return (
    <Container>
      <h1>Minhas Solicitações</h1>
      <Card>
        <p>Total</p>
        <CountUp duration={1} end={ordersTotal} />
      </Card>
      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              marginBottom: 25,
            }}
          >
            <ViewInput
              style={{ width: "100%", maxWidth: 200, marginRight: 15 }}
            >
              <p>Filtrar por Técnicos</p>
              <Select
                placeholder="selecionar técnico"
                value={collaborator_id}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setCollaborator_id(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Técnicos</Select.Option>
                {collaborators.map((item) => {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
            <ViewInput
              style={{ width: "100%", maxWidth: 200, marginRight: 15 }}
            >
              <p>Filtrar por Status</p>
              <Select
                placeholder="selecionar status"
                value={status}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setStatus(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Status</Select.Option>
                <Select.Option value="andamento">Em andamento</Select.Option>
                <Select.Option value="finalizado">Finalizado</Select.Option>
                <Select.Option value="alteracao">
                  Alteração Solicitada
                </Select.Option>
                <Select.Option value="pendente">
                  Documentação Pendente
                </Select.Option>
                <Select.Option value="pagamento">
                  Aguardando Pagamento
                </Select.Option>
                <Select.Option value="recusado">Recusado</Select.Option>
                <Select.Option value="cancelado">Cancelado</Select.Option>
                <Select.Option value="aberto">Aguardando Técnico</Select.Option>
              </Select>
            </ViewInput>
          </div>
          {orders.length == 0 && (
            <Message>Nenhuma Ordem de Serviço encontrada</Message>
          )}
          <div className="orders">
            {orders.map((item) => {
              return (
                <div className="order">
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {item.urgent && (
                      <Status
                        isUrgent={true}
                        style={{
                          marginRight: 10,
                          marginBottom: 7,
                          flexFlow: "nowrap",
                        }}
                      />
                    )}
                    {item.name && (
                      <p
                        style={{ width: "100%", fontSize: 11, marginBottom: 8 }}
                      >
                        {item.name}
                      </p>
                    )}
                  </div>

                  <div style={{ flex: 1 }}>
                    <p className="title">{("0000" + item.id).slice(-4)}</p>
                    <p
                      className="back"
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      {item.totalServices} serviços
                    </p>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{ width: 220, marginRight: 35 }}>
                      <p className="title">Status</p>
                      <Status status={item.status} urgent={item.urgent} />
                    </div>
                    <div className="item" style={{ marginRight: 35 }}>
                      <p className="title">Última atualização</p>
                      <p
                        className="back"
                        style={{
                          fontSize: 12,
                        }}
                      >
                        {format(new Date(item.update_at), "dd/MM/yyyy HH:mm")}
                      </p>
                    </div>
                    <div className="item" style={{ width: 150 }}>
                      <p className="title">Técnico</p>
                      <p
                        className="back"
                        style={{
                          fontSize: 12,
                          maxWidth: 150,
                        }}
                      >
                        {item.collaborator?.name || "Sem Técnico"}
                      </p>
                    </div>
                  </div>
                  <Button
                    type="primary"
                    onClick={() => {
                      navigate("/cliente/os/" + item.id);
                    }}
                  >
                    Detalhes
                  </Button>

                  {!!item.averageTime && (
                    <p style={{ width: "100%", fontSize: 11, marginTop: 10 }}>
                      OS concluida em{" "}
                      {formatarDuracaoCompleta(
                        intervalToDuration({
                          start: new Date(),
                          end: addSeconds(new Date(), item.averageTime),
                        })
                      )}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
          <Pagination
            style={{
              margin: "25px 0",
              alignSelf: "center",
            }}
            defaultCurrent={page + 1}
            pageSize={30}
            onChange={(page) => {
              setPage(page - 1);
            }}
            total={ordersTotal}
          />
        </>
      )}
    </Container>
  );
}
